var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { LabelBlock } from '../../components/CommonModal/styles';
import SelectForModal from '../../components/Forms/Fields/SelectForModal';
import Modal from '../../components/CommonModal';
import { makeSelectApps } from '../Root/selectors';
import { useSelector, useDispatch } from 'react-redux';
import { Description, Label } from './styles';
import { InfoTooltip } from '../../app-builder/utils/InfoTooltip';
import { COLORS } from '../../themes';
import { createPushMultiApp, loadPushMultiApps, } from '../../store/pushMultiApps/actions';
import toast from '../../components/Toast';
import { selectSenderApps } from '../../store/pushMultiApps/selectors';
var CreateModal = function (_a) {
    var _b;
    var appId = _a.appId, isVisible = _a.isVisible, setIsVisible = _a.setIsVisible;
    var dispatch = useDispatch();
    var _c = useState(''), senderAppId = _c[0], setSenderAppId = _c[1];
    var appsOfCurrentOrg = useSelector(makeSelectApps());
    var senderApps = useSelector(selectSenderApps);
    var appsOptions = (_b = appsOfCurrentOrg === null || appsOfCurrentOrg === void 0 ? void 0 : appsOfCurrentOrg.filter(function (a) {
        var _a;
        return !senderApps.some(function (s) { return s.parent_app === a.id; }) &&
            a.id !== appId &&
            ((_a = a.platform_version) === null || _a === void 0 ? void 0 : _a.minor) > 19;
    })) === null || _b === void 0 ? void 0 : _b.map(function (app) { return ({
        value: app.id,
        label: app.name,
    }); });
    return (_jsx(Modal, { isVisible: isVisible, setIsVisible: setIsVisible, title: "Add new app", titleBlockBorderBottom: true, modalBody: _jsxs(_Fragment, { children: [_jsx(Description, { children: "This powerful feature lets you effortlessly send push notifications to all your connected apps from a single interface. Once you link a new app, it becomes instantly possible to broadcast messages from the newly added app to others in the network." }), _jsxs(LabelBlock, __assign({ withHelperText: true }, { children: [_jsx(Label, { children: "App Name" }), _jsx(InfoTooltip, { info: _jsx(_Fragment, { children: "Content needed" }), color: COLORS.archive })] })), _jsx(SelectForModal, { margined: true, name: "app", value: appsOptions.find(function (app) { return app.value === senderAppId; }), options: appsOptions, onChange: function (value) {
                        setSenderAppId(value.value);
                    }, style: { marginTop: 0 }, placeholder: Boolean(appsOfCurrentOrg.length) ? 'Enter app name' : 'Loading...' })] }), actionButtonContent: "Add New App", actionButtonOnClick: function () { return __awaiter(void 0, void 0, void 0, function () {
            var created;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dispatch(createPushMultiApp(appId, senderAppId))];
                    case 1:
                        created = _a.sent();
                        if (created) {
                            dispatch(loadPushMultiApps(appId));
                            toast.success('Sender app added');
                        }
                        else {
                            toast.error('Something went wrong while adding the app');
                        }
                        setIsVisible(false);
                        return [2 /*return*/];
                }
            });
        }); }, cancelText: "Dismiss" }));
};
export default CreateModal;
